module.exports = __webpack_public_path__ + "static/media/googlePlayBadge.da1c4982.svg";